<template>
    <div>
      <div @click="go_url()">
        <img style="border: 1px solid" width="100%" :src="definition.details.public_url" />
      </div>
    </div>
    
</template>

<script>
    export default {
        name: "ReportCompImage",
        props: ['definition'],
        data() {
            return {
                some_var: null,
            }
        },
        methods: {
          go_url() {
            let destination = this.definition.details.public_url
            if (this.definition.details.source_url) {
              destination = this.definition.details.source_url
            }
            window.open(destination,'_blank')
          },
        }
    }
</script>
